<!--banner及合作单位、支持单位-->
<template>
    <div id="bannerCompany" class="mt20">
        <div class="content myflex">
            <div class="banner-box mr20 sec">
                <el-carousel trigger="click" height="348" indicator-position="none" :interval="5000">
                    <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                        <div class="banner-img relative" :style="'background:url('+item.cover+') no-repeat center;'" 
                            @click="bannerDetail(item.sourceId,item.sourceType,item.hyperlink)">
                            <h3 class="banner-title ellipsis1">{{ item.title }}</h3>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>

            <div class="sec shequEdu-l pad15 myflex-lv">
                <div>
                    <h4 class="shequEdu-l-title fon18 fweight theme-color">全民终身学习教育资源共享行动</h4>   
                    <div class="shequEdu-l-con">
                        <p>为深入学习贯彻习近平总书记关于教育的重要论述和全国教育大会精神，落实党的十九届四中全会提出的“构建服务全民终身学习的教育体系”精神，落实“教育现代化2035”规划，推动社区教育健康有序规范化发展。根据教职成司“进一步开展社区教育和老年教育资源共享行动的通知”精神，开展全民终身学习教育资源共享行动。北京师范中国艺术教育研究中心（所）会同中国成人教育协会艺术教育专业委员会和中国合唱协会、启功书院等学术单位和组织单位共同组织开展，“组织教育资源进社区、进机构、进农村”，“探索区域间、机构间的资源共建共享的创新机制”，“创新实施网上社区教育大讲堂”。构建社会艺术教育人才库，开展美育教师培训等 。
        2020年，开展了系列”音乐战疫“、”书法战疫“、”钢琴战疫“活动。
        2021年，协助社区教育机构向艺术教育核心素养教学转型的系列活动和网上社区教育大讲堂活动。
        2022年，根据社区教育制度化规范化发展研究与实践项目（艺术类）工作要求发布了《社会艺术教育标准》，为全民终身学习核心素养提升奠定了坚实基础。以《标准》为指引，中国成人教育协会艺术教育专业委员会将在音乐、舞蹈、戏剧、影视、演讲与口才、书法等领域开展美育教师师资培训，建立社会艺术教育人才共享库，搭建社会美育教师成长阶梯，构建科学的资历框架。
</p>
                    </div>
                </div>
                <div>
                    <span class="sCicle sCicle1"></span>
                    <span class="sCicle sCicle2"></span>
                    <span class="sCicle sCicle3"></span>
                    <span class="sCicle sCicle4"></span>
                </div>
            </div>

            <!--废弃-->
            <div class="conpany-box flex1 marginauto-l sec" v-if="false">
                <div class="sec-right-up">
                    <div class="look-more" @click="toList">查看更多<i class="el-icon-arrow-right"></i></div>
                </div>
                <el-tabs v-model="activeName">
                    <el-tab-pane name="first">
                        <template v-slot:label>
                            <b class="tabTitle">参与研究的专业合作单位</b>
                        </template>
                        <template>
                            <div class="list-box list-box1" v-if="conpanyList1.length>0">
                                <div class="list-item myflex-v" v-for="(cItem1,cIndex1) in conpanyList1" :key="cIndex1" @click="toDetail(cItem1.id)">
                                    <i class="el-icon-arrow-right list-icon"></i>
                                    <div class="list-text ellipsis1 marginauto-l flex1">{{cItem1.unitName}}</div>
                                </div>
                            </div>
                            <div v-else class="nodata pad15">暂无数据~</div>
                        </template>
                    </el-tab-pane>
                    <el-tab-pane name="second">
                        <template v-slot:label>
                            <b class="tabTitle">教育行政主管部分支持单位</b>
                        </template>
                        <template>
                            <div class="list-box list-box1" v-if="conpanyList1.length>0">
                                <div class="list-item myflex-v" v-for="(cItem2,cIndex2) in conpanyList2" :key="cIndex2" @click="toDetail(cItem2.id)">
                                    <i class="el-icon-arrow-right list-icon"></i>
                                    <div class="list-text ellipsis1 marginauto-l flex1">{{cItem2.unitName}}</div>
                                </div>
                            </div>
                            <div v-else class="nodata pad15">暂无数据~</div>
                        </template>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .banner-box{width:591px;min-width:591px;height:351px;}
    .banner-box>>>.el-carousel__container{height:100% !important;}
    .banner-img{width:100%;height:100%;background-size:cover !important;}
    .banner-title{position:absolute;background:rgba(0,0,0,.3);padding:10px 10px;bottom:0;left:0;right:0;font-size:14px;color:#fff;}
    .list-item{cursor:pointer;}
    .list-icon{margin:0 10px 0 20px;border-radius:50%;padding:1px;font-size:12px;background:rgba(0,0,0,.3);color:#fff;}
    .list-text{border-bottom:1px dashed #ddd;padding:8px 0px 8px 0;margin-right:15px;}
    .list-item:last-child .list-text{border-bottom:none;}
    .conpany-box{width:668px;}
    .list-box{height:220px;overflow-y:auto;}

    .shequEdu-l{position:relative;padding:15px;}
    .shequEdu-l-title{line-height:1.5;text-align:center;margin-bottom:10px}
    .shequEdu-l-con{text-indent:2em;line-height:1.4;font-size:13px;white-space:pre-wrap;}
    .sCicle{position:absolute;width:14px;height:14px;background:#eee;border:.5px solid #eee;border-radius:50%;}
    .sCicle1{top:10px;left:10px;}
    .sCicle2{top:10px;right:10px;}
    .sCicle3{bottom:10px;left:10px;}
    .sCicle4{bottom:10px;right:10px;}

    @media screen and(max-width:1200px){
        .content{flex-wrap:wrap;}
        .banner-box{margin:0 0 20px 0 !important;width:100%;height:56vw;min-width:200px;}
    }
</style>

<script>
export default {
    name: "bannerCompany",
    components: {
    },
    data(){
        return {
            art: art,
            bannerList: [
                //{thumb:'studioLiveCover/20180914144033.jpg',title:'1'},
            ],
            activeName: 'first',
            conpanyList1: [
                //{id:1, unitName:'我家哦个仅供产物傲娇；爱丽丝肯德基拉斯肯德基抵扣积分我家哦个仅供产物傲娇；爱丽丝肯德基拉斯肯德基抵扣积分电动蝶阀阿斯蒂芬'},
            ],
            conpanyList2: [
                //{id:1, unitName:'1我家哦个仅供产物傲娇；爱丽丝肯德基拉斯肯德基抵扣积分我家哦个仅供产物傲娇；爱丽丝肯德基拉斯肯德基抵扣积分电动蝶阀阿斯蒂芬'},
            ],
        }
    },
    methods:{

        //banner
        getBannerList(){
            this.$api.web.websitContentGetBannerList({channel:1}).then(res=>{
                console.log(res);
                var l = res.body.bannerList;
                for(var i in l){
                    l[i].cover = art.addOssurlHeader(l[i].thumb)
                }
                this.bannerList = l;
            }).catch(res=>{})
        },

        //点击banner
        bannerDetail(id,type,link){
            if(type==0) {
                return;
            }
            //公告
            else if(type==2 ){
                if(!id) return;
                const newurl = this.$router.resolve({name: 'newsActivityDetail', query: {id:id}})
                window.open(newurl.href,'_blank');
            }
            //外链
            else if(type==3){
                window.open(link,'_blank');
            }
        },

        //获取合作单位1、支持单位列表2
        getUnitList(type){
            var data = {
                type: type,
                pageNum: 1,
                pageSize:6,
            }
            this.$api.web.websitContentGetCooperationUnitList(data).then(res=>{
                this['conpanyList'+type] = res.body.cooperationUnitList;
            }).catch(res=>{})
        },
        
        //跳到单位详情页面
        toDetail(id){
            const newurl = this.$router.resolve({path: '/companyDetail', query: {id: id}})
            window.open(newurl.href,'_blank');
        },

        //跳到单位列表页面
        toList(){
            const newurl = this.$router.resolve({path: '/companyList', query: {}})
            window.open(newurl.href,'_blank');
        },
    },
    created(){
        this.getBannerList();
    },
    mounted(){
        /* 该模块已废弃
        setTimeout(()=>{
            this.getUnitList(1);
        },100)
        setTimeout(()=>{
            this.getUnitList(2);
        },300)
        */
    },
};
</script>
